export const enTexts = {
  // Titles
  encyclopediaTitle: "Ghalichin Encyclopedia",
  insuranceAndServicesTitle: "Ghalichin insurance And Services",
  generatorTitle: "Ghalichin Generator",

  home: "home",
  contactUs: "contact Us",
  loginRegister: "login/ Register",
  encyclopedia: "Encyclopedia",
  vr: "virtual reality",
  buy: "buy",
  loading: "loading",
  rugGenerate: "carpet layout",
  insuranceAndServices: "insurance And Services",
  insurance: "insurance",
  brand: "brand",
  shaneh: "Reeds",
  density: "density",
  yarn: "yarn",
  rug_size_6: "rug_size_6",
  rug_size_9: "rug_size_9",
  rug_size_12: "rug_size_12",
  decoration: "decoration",
  room_services: "services:",
  floor_covering: "floor",
  wall: "wall",
  roof: "roof",
  selectImage: "select Image",
  wishListText:
    "You can add the created carpets to the favorites list to see a preview of them later.",
  services: "services",
  specialPosts: "special Posts",
  preview: "preview",
  lachakToranj: "lachak Toranj",
  modern: "modern",
  afshan: "afshan",
  kheshti: "kheshti",
  border: "border",
  corner: "corner",
  background: "background",
  toranj: "toranj",
  tile: "tile",
  pattern: "pattern",
  rugSettings: "tile",
  wishList: "wishList",
  addToWishList: "add To Wish List",
  listIsEmpty: "listIsEmpty",
  rotate: "rotate",
  clear: "clear",
  latest: "latest",
  oldest: "oldest",
  onSale: "onSale",
  searchingForSellers: "searching For Sellers",
  storesForThisRug: "stores For This Rug",
  noStoreForSelectedRug: "no Store For Selected Rug",
  selectOneSimilarRug: "select One Similar Rug",
  selectedRugs: "selected Rugs",
  rugSimilarityPercentage: "rug Similarity Percentage",
  similarRugs: "similar Rugs",
  availableRugSizes: "available Rug Sizes",
  phoneNumber: "phone Number",
  address: "address",
  filters: "filters",

  previewEmptyHelpText: "You must add at least one rug to the list",

  // Texts

  landingText: `Creating added value for the buying process is one of the major concerns of any business. This added value can be examined and acted upon in three ways. From the point of view of the consumer, the seller and ultimately the producer.Ghalichin goal is to create this added value in a digital and secure platform. Our approach is to offer the sale and purchase of"carpet goods" in a new and reliable environment`,
  wikipediaBoldText: `What is the difference between machine-made and Hand-knotted carpets? What should I pay attention to when choosing a quality carpet? How do I choose the size of the carpet? What is the right carpet color for my decor? What does comb and density in a car carpet mean? What does Raj mean in Hand-knotted?`,
  wikipediaLightText: `Sufficient information before purchasing is one of the requirements for purchasing any product. Ghalichin in the encyclopedia section seeks to answer your questions and provide the most accurate information about the material, design, elegance, fibers, color, dimensions and design of the carpet and rug`,
  layOutBoldText: `What was my neighbor's carpet like? Do you agree that the background of their carpet was very similar to our home decor?
I wish I could see the details of the carpets carefully without going around the market from home and not bother the sellers`,

  layOutLightText: `carpet layout is our special and exclusive service for those who are interested in playing with the details of their carpet and finding the closest carpet to their choice and preparing it from the nearest carpet to solve their residence`,
  VRBoldText: `Ich wünschte, wir würden sagen, bringen Sie alle vier Teppiche nach Hause und wir werden einen auswählen. Passt ein moderner Teppich mehr zu unserem Dekor oder zu einem traditionellen? Wird der Teppich auf dem Parkett gut sein?`,

  VRLightText: `It may have happened to you that when you buy carpets, you like some of the designs, but it is not possible for you to spread all these carpets in your house and see their appearance with your home decoration and choose the best option.Ghalichin has many ideas for this need of yours. Simulating your home is the beginning of this path and will continue`,
  shoppingBoldText: `Do you know from whom you are buying? Can it be trusted, is it not a scam? Do they send the carpet? Isn't it better to buy in person?`,
  shoppingLightText: `Creating a secure platform for trade has always been a concern for consumers and sellers. Trust in the online sales environment is far more complex, and this is one of the obstacles to the expansion of this market, especially for valuable products. Galichin has tried to provide a safe and reliable sales platform for buying carpets for consumers and selling carpets for suppliers by creating appropriate mechanisms`,
  insuranceBoldText: `I wish the seller would do the carpet washing periodically? Where can I wash the carpet so that it does not spoil? I wish they would take our old carpet and replace it with a new one for a certain amount!Is there a place where I can rent a carpet? Do they rent new carpets?`,

  insuranceLightText: `After-sales service and warranty of valuable goods such as carpets will make shopping more enjoyable and safer for each customer. According to the needs of customers, while providing various after-sales services, Ghalichin offers other valuable services. Services such as free washing! Replace your old carpet with a new one! And carpet rental service for your short-term use of carpets !!! `,

  insuranceText: `We are all interested in buying from a place that offers us the best options both at the time of purchase and after-sales service. Ghalichin also offer a variety of services in this regard. For example, the consumer. A person who has bought the carpet from Ghalichin with insurance can benefit from the first free washing of his carpet or after a while he will receive a new carpet by paying a part of the cost. Carpet rental service is another service that will be launched soon`,

  servicesText: `We are all interested in buying from a place that offers us the best options both at the time of purchase and after-sales service. Ghalichin also offer a variety of services in this regard. For example, the consumer. A person who has bought the carpet from Ghalichin with insurance can benefit from the first free washing of his carpet or after a while he will receive a new carpet by paying a part of the cost. Carpet rental service is another service that will be launched soon`,
  firstLandingText: `Welcome to the virtual journey of the customer of Qalichin site.
  In this journey, we are with you in five sections.
  The first step is to get correct and reliable information in the encyclopedia. The second step is to make buying a carpet attractive for you with a carpet arrangement service that allows you to personalize the carpet. Now, in the third step or the virtual reality, for more certainty and a safer virtual purchase, we go to two-dimensional and three-dimensional simulators where you can prepare the carpet more harmoniously with the decoration of your home. very good. You have made your choice, now it's time to pay the price. The fourth step of buying carpets is the carpet market where you find the best price from the nearest place and place an order. Congratulations, you have been added to the tribe of Qalichin. Yes, that's right, the fifth step of this journey starts after your purchase. The fifth step is the insurance and services that are our commitments to you, a new member of Qalichin.
  We are very happy that you chose Qalichin and became our traveling companion
  We hope you have a good shopping and enjoy your trip.
  Select the section you want from the toolbar above.`,
  encyclopediaEndText: `Encyclopedia:
  <br/>
  From fabric to pattern
  <br/>
  The first step of any purchase is to have enough information about the product.
  Our first source of information when buying a product is its sellers. Now there is the question, is all the information that the sellers give us correct and reliable, or do we need a more reliable source to make a decision?
  Having a multimedia space to introduce textile products and carpets in particular by manufacturers and sellers and providing a space for consumers to share their opinions and express their shopping experiences is a strong point for safe shopping.
  <br/>
  Some examples of competitive advantages offered in such a platform: From the perspective of consumers:
  <br/>
  Are all sellers honest with you?
  Is all the information they give you correct?
  <br/>
  From the seller's point of view:
  <br/>
  Are the products of their store introduced in the best way?
  Does the statistical society know them correctly?
  <br/>
  From the producers' point of view:
  <br/>
  Is the competitive advantage of the products they produce sufficiently introduced and known?
  Do they need to be introduced in newer spaces?`,
  generatorEndText: `Carpet arrangement:
  <br/>
  Carpets and patterns
  <br/>
  The second step for a safe and reliable purchase is to make it enjoyable and choose the product out of satisfaction, not out of tiredness and conviction or being forced to choose.
  <br/>
  All of us are familiar with carpet and its design and role since childhood, according to our cultural background and lifestyle
  This visual familiarity allows us to be expert carpet experts when buying carpets
  If it was possible for all of us to have a hand in the design of carpets, we would definitely take advantage of this opportunity.
  So that maybe we can reach a better plan from our carpet design or put our personal plan to the test and touchstone of authentic Iranian plans. In the carpet layout section, this delightful possibility has been created for you to personalize your design and pattern and reach your favorite design more easily with the variety game of choosing a map.
  In addition to this, analyzing and checking the possibility of the texture of your exclusive map will be easily possible with a few simple factors
  <br/>
  Some examples of competitive advantages offered in such a platform:
  <br/>
  From the perspective of consumers:
  Market maps can be changed and personalized.
  The map designed by the customer is checked with the maps available in the market and the closest maps are introduced to the customer.  From the seller's point of view:
  The game of diversifying the purchase process and making the carpet selection process more attractive
  Sharing the customer's taste in the buying process and facilitating the selection of carpets
  <br/>
  From the producers' point of view:
  <br/>
  Analyzing customer taste based on selected pieces and directing the design unit towards the market trend
  Targeting the production and presentation of the texture platform of exclusive maps of customers in the form of limited edition`,
  vrEndText: `virtual reality:
  <br/>
  Carpets and decorations
  <br/>
  The third step of the carpet virtual journey is to simulate with 2D and 3D tools and create virtual tours for stores that may not be close to you, but you are interested in visiting them.
  <br/>
  One of the concerns when buying a product is always the coordination of the product with other household goods
  Now that the time has come to choose a carpet, this coordination will be much more important because the matter of coordinating the carpet with the home decoration is in the middle. One of the solutions is carpets in homes.
  But when the number of plans is large and carpet transportation is a problem, technology comes into action and provides simpler solutions.
  Some examples of competitive advantages offered in such a platform: From the consumer's point of view:
  View the products offered in stores without the need to travel
  Viewing all kinds of carpet designs in the desired space using simulation tools
  <br/>
  From the distributor's point of view:
  <br/>
  Benefiting from software platforms to attract more visits to their store
  Using technological systems to reduce the cost of carpeting in the customer's home
  <br/>
  From the producer's point of view:
  <br/>
  Create a virtual tour of the factory and display products for the network of wholesalers
  Shortening and simplifying the process of ordering products for shopkeepers who find it difficult to visit the factory`,
  buyEndText: `Buy:
  <br/>
  Carpets and stores
  <br/>
  The fourth step of Qalichin's virtual journey is to provide a virtual marketplace or marketplace of brands
  <br/>
  After the three previous stages in this virtual journey to the purchase stage, the customer will have concerns such as the price and the quality of the selected products.
  In this situation, it seems very necessary to benefit from a marketplace that can carry out price and quality checks safely and without spending time and money.
  In this market, monitor other people's purchases, see customer satisfaction, and ensure after-sales service, so that you can finally place a suitable order from your home with complete peace of mind.
  <br/>
  Some examples of competitive advantages offered in such a platform: From the consumer's point of view:
  <br/>
  Checking the price of the desired goods from several suppliers
  Checking the credibility and customer satisfaction of suppliers of goods based on the survey of old buyers
  <br/>
  From the distributor's point of view:
  <br/>
  Presenting your products online without the need to send samples or warehouse
  More dynamic interaction with the consumer and the launch and notification of special sales
  <br/>
  From the producer's point of view:
  <br/>
  Providing a product portfolio of producer products in the market without intermediaries and brokers
  Getting direct feedback from the final consumer and directing production based on market demand`,
  insuranceEndText: `Insurance and services:
  <br/>
  Carpet and peace
  <br/>
  The fifth and last step of the virtual customer journey is the addition of the buyer to the Qalichini clan.
  Selling is never the end of the story.
  The purpose of a business is not to sell a product or serve a customer and end this flow, if it is, the word successful cannot be used for it.
  The purpose of creating this section is networking. A network of services and interactions.
  After buying a carpet, different needs will arise for the customer. Such as washing, fixing possible faults and repairing the carpet, having a guarantee and guaranteeing the quality and even after using the carpet for a while, the need to sell the second-hand carpet or replace the old carpet with a new carpet in the market. All these services can be provided if we have a correct view of the sales process and have prepared the necessary platforms for the continuation of the after-sales service process.
  Some examples of competitive advantages offered in such a platform:
  <br/>
  From the consumer's point of view:
  <br/>
  Safe and guaranteed purchase from a collection with multiple services
  Creating a platform for the second-hand market and the market for replacement carpets
  <br/>
  From the distributor's point of view:
  <br/>
  Benefiting from a coherent and continuous sales network
  Introducing and identifying yourself to customers as a superior service unit
  <br/>
  From the producer's point of view:
  <br/>
  In the fast-paced and competitive world of business, better and more service is equivalent to a better and better known brand
  Expansion and development of the customer club`,
  welcome:
    "Welcome to the virtual journey of the customer of ghalichin site. In this journey, we are with you in five parts.",
  hande_made: "handmade carpet",
  machine: "machine woven carpet",
  first_step: `The first step is to get correct and reliable
  information in the encyclopedia.`,
  scond_step: `The second step is to make carpet shopping attractive
  to you with carpet fitting services that allow you to personalize the
 carpet.`,
  market_carpet: "market carpet",
  your_own_carpet: "Your own carpet",
  your_photo: "your photo",
  third_step: `In the third stage, i.e. virtual reality, for more confidence and safer virtual shopping, we go to two-dimensional and three-dimensional simulators, where you can prepare the carpet more harmoniously with your decoration and home. very good. You've made your choice, now it's time to pay.`,
  virtual_tour: "virtual tour",
  threeD: "Three-dimensional",
  Two_dimensional: "Two-dimensional",
  fourth_step: `The fourth stage of buying a carpet is the carpet market,
  where you find the best price from the nearest place and order. Congratulations, you have joined the Qalichin family.`,
  market: "Market",
  gazette: "Gazette",
  fifth_step: `The fifth step of this journey starts after your purchase.
  The fifth step is the insurance and services that are our commitments to you, a new member of Qalichin.`,
  secondhand: "Secondhand",
  replace: "Replace old with new",
  inshurance: "Carpet insurance",
  size_selection: "size selection",
  select_image: "Select image",
  confirm_and_pay: "confirm and send",
  selection_size_description: "Please choose one of the carpet sizes you want",
  image_registration: "Image registration",
  zoom: "magnification",
  confirmation_and_approval: "Confirmation and approval",
  name_and_lastname: "first name and last name",
  Phone_call: "Phone Call",
  Address: "Address",
  send: "send",
  ordering: "Ordering",
  carpet_show: "Carpet show",
  back_market: "Back to the market",
  next: "next one",
  previous: "previous",
  carpet_link: "The link of the carpet you want",
  national_Code: "National Code",
  upload_photo_and_video: "Upload photos and videos of your carpet",
  photoـorـvideoـlink: "Photo or video link",
  coming_back: "coming back",
  the_link_of_the_carpet_you_want: "The link of the carpet you want",
  landing_tab:
    "Use the top menu for a complete introduction of each section, and use the bottom menu for faster access.",
  carpet_replacement: "Carpet replacement",
  submit: "submit",
  receiving_information: "Receiving information",
};
